export const PRIMARY_RED = '#B51F2B'
export const SECONDARY_GRAY = '#535353'